import {ItemResponseSspBeanObject, ListResponseSspInfoBean, SspBean, SspControllerApi} from 'common/api/api.ts'
import {BaseApi, configuration} from 'common/api/BaseApi.ts'
import {processError} from 'common/api/fetch.ts'

let currentDate = new Date();

class SspApi extends BaseApi {
  api: SspControllerApi;

  constructor() {
    super();
    this.api = new SspControllerApi(configuration, configuration.basePath, this.fetch);
  }

  all(): Promise<ListResponseSspInfoBean> {
    return this.api.sspList().then(list => {
      return Promise.resolve(list);
    }).catch(err => {
      return processError(err);
    });
  }

  create(ssp: any): Promise<ItemResponseSspBeanObject> {
    return this.api.createSsp(ssp).then(created => {
      return Promise.resolve(created);
    }).catch(err => {
      return processError(err);
    });
  }

  edit(id: number, ssp: SspBean): Promise<ItemResponseSspBeanObject> {
    return this.api.editSsp(ssp, id).then(updated => {
      return Promise.resolve(updated);
    }).catch(err => {
      return processError(err);
    });
  }

  view(id: number): Promise<ItemResponseSspBeanObject> {
    return this.api.ssp(id).then(ssp => {
      return Promise.resolve(ssp);
    }).catch(err => {
      return processError(err);
    });
  }

  delete(id: number): Promise<void> {
    return this.api.deleteSsp(id).then(() => {
      return Promise.resolve();
    }).catch(err => {
      return processError(err);
    });
  }

  generateToken(id: number): Promise<string> {
    return this.api.generateSspToken(id)
  }

  generateApiReportLink(token: any) {

    let startDate = new Date(Date.UTC(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    )).toISOString().split('T')[0].replace(/-/g, '');

    let currentDateStr = currentDate.toISOString().split('T')[0].replace(/-/g, '');

    return token != undefined ? configuration.basePath + '/stats/' + token + '/' + startDate + '/' + currentDateStr : '';
  }

  async changeStatus(id: number) {
    try {
      const ssp = await this.api.changeSspStatus(id);
      return Promise.resolve(ssp);
    } catch (err) {
      return processError(err);
    }
  }
}

const sspApi = new SspApi();

export default sspApi;
